import React, { useState, useEffect } from 'react';

import { Checkbox, Divider } from 'antd';

const CheckboxGroup = (props) => {
  const { options, defaultValue = [], onChange = () => {}, checkAll = false, checkAllText = 'Check All' } = props;

  const [checkedList, setCheckedList] = React.useState(props.defaultValue);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [_checkAll, setCheckAll] = React.useState(false);

  const _onChange = (list) => {
    setCheckedList(list);
    setIndeterminate(!!list.length && list.length < options.length);
    setCheckAll(list.length === options.length);
  };

  const onCheckAllChange = (e) => {
    setCheckedList(e.target.checked ? options.map((row) => row.value) : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  useEffect(() => {
    onChange(checkedList);
  }, [checkedList]);

  return (
    <>
      {checkAll === true ? (
        <>
          <Checkbox {...props} indeterminate={indeterminate} onChange={onCheckAllChange} checked={_checkAll}>
            {checkAllText}
          </Checkbox>
          <Divider />
        </>
      ) : (
        undefined
      )}
      <Checkbox.Group options={options} value={checkedList} onChange={_onChange} defaultValue={defaultValue} />
    </>
  );
};

export default CheckboxGroup;
